'use strict';

angular.module('clientDashboardApp').service('locationUploadService', function ($q, $http) {
  function LocationUploadService() {
  }

  LocationUploadService.prototype.import = function (locationImportId) {
    var deferred = $q.defer();
    $http
      .get('/admin/location/uploadLocations/import/' + locationImportId)
      .success(function (data, status, headers, config) {
        deferred.resolve(data);
      })
      .error(function (data, status, headers, config) {
        deferred.reject('Error occurred when importing locations!');
      });
    return deferred.promise;
  };

  var locationUploadService = new LocationUploadService();
  return locationUploadService;
});
